import React, { PropsWithChildren } from 'react';
import { Fieldset, FieldsetModifier } from '../Fieldset/Fieldset';
import { Row } from '../../grid/Row/Row';
import bem from '../../../../lib/bemUtils/bem';

type RadioGroup = PropsWithChildren<{
  legend: string;
  orientation?: 'vertical' | 'horizontal';
  fieldsetModifier?: FieldsetModifier;
  required?: boolean;
}>;

export function RadioGroup({
  legend,
  orientation = 'horizontal',
  fieldsetModifier,
  children,
  required = false,
}: RadioGroup) {
  return (
    <Fieldset modifier={fieldsetModifier} legend={legend} required={required}>
      <Row>
        <div className={bem('radio-group', orientation)}>{children}</div>
      </Row>
    </Fieldset>
  );
}
